import React, { useEffect } from 'react';
import Routes from './routes';
import {useSelector, useDispatch} from 'react-redux'


function App()  {
    const dispatch=useDispatch();
    useEffect(() => {
        document.body.classList.toggle('fiscal-dark-theme', localStorage.getItem('fiscal_theme') == 'dark');
    }, []);
    let token = localStorage.getItem('token');
    dispatch({type:'login',payload:{token:token,user:{}}});

    return (
        <Routes />
    );
}

export default App;
